import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "edit-props-container form-container"
};
const _hoisted_2 = {
  class: "text-area-container"
};
const _hoisted_3 = {
  key: 0,
  class: "operator-container"
};
const _hoisted_4 = {
  key: 1,
  class: "operator-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElButton, ElCol, ElForm, ElInput, ElInputNumber, ElMessage, ElOption, ElRow, ElSelect } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { calculateMD5, compressImage, placeholderImage } from '@/tools/utils'; // constants
// pre-declaration

export default {
  __name: 'DramaEditCard',
  props: {
    dramaId: {
      type: [String, Number, null],
      default: () => null,
      required: false
    }
  },
  emits: ['close', 'reload'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const updateForm = ref({
      id: null,
      name: '',
      difficulty: 0,
      construction_period: '',
      era: '',
      location: '',
      description: '',
      oddment: '',
      nature: null,
      tendency: []
    });
    const imageInput = ref(null);
    const dramaImage = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const natureOptions = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.drama_nature ?? null;
    });
    const tendencyOptions = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.drama_tendency ?? null;
    });
    const tendencyIdMap = computed(() => {
      if (!tendencyOptions.value) return {};
      const buffer = {};
      tendencyOptions.value.forEach(item => {
        buffer[item.id] = item.desc;
      });
      return buffer;
    });
    const tendencyDescMap = computed(() => {
      if (!tendencyOptions.value) return {};
      const buffer = {};
      tendencyOptions.value.forEach(item => {
        buffer[item.desc] = item.id;
      });
      return buffer;
    });
    const tendencyDesc = computed(() => {
      const buffer = [];

      for (const item of updateForm.value.tendency) {
        buffer.push(tendencyIdMap.value[item]);
      }

      if (buffer.length !== 0) {
        return `剧本标签（${buffer.join(';')}）`;
      }

      return '剧本标签';
    }); // functions

    const getData = () => {
      if (!worldOutlook.value) return;
      if (!tendencyOptions.value) store.dispatch('get_drama_tendency');
      if (!natureOptions.value) store.dispatch('get_drama_nature');

      if (props.dramaId) {
        request('drama/get/', {
          'drama_id': props.dramaId,
          'is_precis': true
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            loadData(response.data);
          }
        });
      }
    };

    const loadData = dramaData => {
      updateForm.value = {
        id: dramaData.id,
        name: dramaData.name,
        difficulty: dramaData.difficulty,
        construction_period: dramaData.construction_period,
        era: dramaData.era,
        location: dramaData.location,
        description: dramaData.description,
        oddment: dramaData.oddment,
        nature: dramaData?.nature?.id
      };
      dramaImage.value = dramaData?.image_url;
      const tendencies = [];
      const tendencyDesc = (dramaData?.tendency ?? '').split(';');

      for (const tendencyItem of tendencyDesc) {
        tendencies.push(tendencyDescMap.value[tendencyItem]);
      }

      updateForm.value.tendency = tendencies;
    };

    const handleInputChange = event => {
      let file = event.target.files[0];

      if (file) {
        compressImage(file, 1024 * 1024, compressedFile => {
          calculateMD5(compressedFile, async md5 => {
            const formData = new FormData();
            formData.append('file', file);
            formData.set('name', file.name);
            formData.set('path', 'drama_images');
            formData.set('md5', md5);
            const headers = {
              'Content-Type': 'multipart/form-data'
            };
            const response = await request('basic/upload_file/', formData, 'UPLOAD', headers); // console.log(`upload stage_image ${JSON.stringify(response)}`)

            if (response.code !== 0) {
              ElMessage.error({
                message: response.msg,
                duration: 1500
              });
            } else {
              dramaImage.value = URL.createObjectURL(file);
              updateForm.value.image_id = response.data['file_id'].toString();
            }

            file = null;
            imageInput.value.value = null;
          });
        });
      }
    };

    const updateTendency = tendencyId => {
      const index = updateForm.value.tendency.indexOf(tendencyId);

      if (index === -1) {
        updateForm.value.tendency.push(tendencyId);
      } else {
        updateForm.value.tendency.splice(index, 1);
      }
    };

    const createDrama = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = updateForm.value;
      parameters.world_outlook_id = worldOutlook.value.id;
      request('drama/create/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '剧本已创建',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const updateDrama = () => {
      if (message.value) {
        message.value.close();
      }

      request('drama/update/', {
        'updates': updateForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '剧本已调整',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544), _createVNode(_unref(ElForm), {
        model: updateForm.value,
        "label-width": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "剧本名称",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: updateForm.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updateForm.value.name = $event),
                maxlength: "64",
                placeholder: "剧本名称",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "剧本时代",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: updateForm.value.era,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updateForm.value.era = $event),
                maxlength: "24",
                placeholder: "剧本时代",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "剧本地点",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: updateForm.value.location,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updateForm.value.location = $event),
                maxlength: "24",
                placeholder: "剧本地点",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "预期时长",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: updateForm.value.construction_period,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updateForm.value.construction_period = $event),
                maxlength: "32",
                placeholder: "预期时长",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "难度系数",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: updateForm.value.difficulty,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updateForm.value.difficulty = $event),
                min: 0,
                max: 100,
                precision: 0,
                placeholder: "难度系数"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "剧本性质",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: updateForm.value.nature,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updateForm.value.nature = $event),
                placeholder: "剧本性质",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(natureOptions.value, item => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: item.id,
                    label: item.desc,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: tendencyDesc.value,
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tendencyOptions.value, item => {
                  return _openBlock(), _createBlock(_unref(ElButton), {
                    key: item.id,
                    class: _normalizeClass(updateForm.value.tendency.includes(item.id) ? 'selected' : ''),
                    onClick: $event => updateTendency(item.id)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.desc), 1)]),
                    _: 2
                  }, 1032, ["class", "onClick"]);
                }), 128))]),
                _: 1
              })]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          style: {
            "align-items": "flex-start"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            src: dramaImage.value ?? _unref(placeholderImage),
            "zoom-rate": 1.2,
            "max-scale": 7,
            "min-scale": 0.2,
            "initial-index": 4,
            "show-progress": "",
            draggable: false,
            fit: "cover",
            onClick: _cache[6] || (_cache[6] = $event => imageInput.value?.click())
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: updateForm.value.description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updateForm.value.description = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "基本描述",
              maxlength: "512"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: updateForm.value.oddment,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => updateForm.value.oddment = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "额外备注",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), __props.dramaId ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ElButton), {
        onClick: updateDrama
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 提交剧本变更 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(ElButton), {
        onClick: createDrama
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 创建剧本 ", -1)]))]),
        _: 1
      })]))]);
    };
  }

};